import { Directive, ElementRef, HostBinding, HostListener, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appCustomBold]'
})
export class CustomBoldDirective implements OnInit {
  @Input() defaultColor:string = 'transparent'
  @Input() highlightColor:string = 'blue'
  @Input() normalFontColor = 'black'
  @Input() highlightFontColor = 'white'
  @HostBinding('style.backgroundColor') backgroundColor:string = this.highlightColor;
  @HostBinding('style.color') textColor:string = this.normalFontColor

  constructor(private eleRef: ElementRef, private renderer: Renderer2) { }


  ngOnInit(){
     this.backgroundColor = this.defaultColor
     this.textColor = this.normalFontColor
  }

  @HostListener('mouseover') mouseover(eventData:Event){
    this.backgroundColor ='#f6f6f6';
    this.textColor = this.normalFontColor;
    this.renderer.setStyle(this.eleRef.nativeElement, 'font-weight', 'bold')

  }

  @HostListener('mouseout') mouseout(eventData:Event){
    this.backgroundColor = this.defaultColor;
    this.textColor = this.normalFontColor;
    this.renderer.removeStyle(this.eleRef.nativeElement,'font-weight')

  }



}
